import React, { memo, useState } from 'react';
import {
  Stack,
  Typography,
  Card,
  Box,
  Icon,
  DialogTitle,
  Dialog,
  DialogContent,
  IconButton
} from 'investira.react.components';
import ObservacoesDetalhe from './ObservacoesDetalhe';

const Observacoes = memo(props => {
  const { data } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Card
        sx={{
          flex: 1,
          display: 'flex',
          minHeight: 0,
          backgroundColor: 'warning.main'
        }}>
        <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
          <Typography variant="caption" color="secondary" sx={{ fontWeight: 500 }}>
            Observações
          </Typography>
          <Stack direction="column" justifyContent="flex-end">
            <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
              <Typography variant="h5" color="secondary">
                <b>{data.response?.resumo.erros.length}</b>
              </Typography>
              <Box
                sx={{ width: '16px', height: '16px', cursor: 'pointer' }}
                onClick={() => setOpen(true)}>
                <Icon iconName={'others'} size={16} color="secondary" />
              </Box>
            </Stack>
          </Stack>
        </Stack>
      </Card>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            Observações
            <IconButton color="primary" onClick={() => setOpen(false)}>
              <Icon iconName="cancel" size={21} />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent>
          <ObservacoesDetalhe data={data} />
        </DialogContent>
      </Dialog>
    </>
  );
});

export default Observacoes;
